<!--
  @OccurredToasts  Shows newly occurred infos at the bottom right of the screen while the timeline is retracted.
  Each info stays visible for SHOW_SECONDS and then fades out; newest infos are on top (like in the timeline).
-->

<script>
		import {untrack} from "svelte";
		import {view} from "../client.svelte.js";
		import {fly, fade} from "svelte/transition";
		import Occurred from "./Occurred.svelte";

		const SHOW_SECONDS = 8     // how long a new info stays visible
		const MAX_TOASTS = 5       // limit of simultaneously shown infos (oldest are dropped)

		// infos already in the timeline when the timeline gets retracted are not shown again
		const seenIDs = new Set(Array.from(view.occurreds, info => info.ID))
		let toasts = $state.raw([])

		$effect(() => {
				for (const info of view.occurreds) {
						if (seenIDs.has(info.ID))  continue
						seenIDs.add(info.ID)
						untrack(() => show_toast(info))
				}
		})

		function show_toast(info) {
				toasts = [info, ...toasts].slice(0, MAX_TOASTS)
				setTimeout(() => toasts = toasts.filter(toast => toast !== info), SHOW_SECONDS * 1000)
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<div class="toasts">
	{#each toasts as info (info.ID)}
		<div class="toast" in:fly={{x: '100%', duration: 600}} out:fade={{duration: 1000}}>
			<Occurred {info}/>
		</div>
	{/each}
</div>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	.toasts
		position: fixed
		right: 20px
		bottom: 16px
		z-index: 9
		width: 360px
		display: flex
		flex-direction: column
		gap: 6px
		pointer-events: none

	.toast
		pointer-events: auto
		background: #222222 url("/static/images/parchment.png") repeat 0 0
		border-radius: 6px
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.3)
		display: flow-root /* to prevent margin collapsing */
</style>
